module.exports = __webpack_public_path__ + "static/img/20010 (2).ed6f94f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20010 (2).webp
// module id = nMZN
// module chunks = 14